import styled from 'styled-components';

export const MainContent = styled.div`
  width: 100%;
  margin-top: 24px;
`;

export const Banner = styled.div`
  .stockup-ai-main-content {
    position: relative;
    display: inline-block;
    margin: auto;
    justify-content: center;
    align-items: center;
    padding: 30px 60px;
    background: url(/images/a369/dang-ky-cong-cu-stockup-ai-bg.svg) no-repeat center;
    background-size: cover;
    color: #fff;
  }
  .stockup-ai-header--name {
    font-size: 36px;
    font-weight: 700;
    text-align: center;
  }
  .stockup-ai-header--name span {
    padding: 1px 6px;
    background: #F0D60B;
    border-radius: 12px 0 12px 12px;
    color: #303030;
  }
  .stockup-ai-header--title {
    max-width: 500px;
    margin: auto;
    font-size: 30px;
    line-height: 1.3;
    text-align: center;
  }
  .stockup-ai-register--title {
    color: #F0D60B;
  }
  .card-button {
    display: inline-block;
    padding: 12px 30px;
    background: #1F2148;
    border-radius: 100px;
    font-weight: 600;
    font-size: 14px;
    line-height: 145%;
    background-color: #f0d60b;
    color: #1f2148;
    text-decoration: none;
    text-align: center;
    transition: all 0.3s ease;
  }
  .card-button .icon {
    display: inline-flex;
    width: 12px;
    height: 12px;
    margin-left: 8px;
    transition: all 0.3s ease;
  }
  .card-button:hover {
    background: #2C2F62;
    color: #fff;
  }
  .card-button:hover path {
    stroke: #fff;
  }
  @media screen and (max-width: 768px) {
    .stockup-ai-main-content .stockup-ai-feature {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
    }
    .stockup-ai-main-content {
      padding: 30px 20px;
    }
    .stockup-ai-header--name {
      font-size: 32px;
    }
    .stockup-ai-header--title {
      max-width: 100%;
      font-size: 26px;
    }
    .stockup-ai-feature li .icon {
      width: 24px;
    }
    .stockup-ai-header--name {
      font-size: 32px;
    }
    .stockup-ai-main-content .stockup-ai-feature {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
    }
    .stockup-ai-feature li .icon {
      width: 24px;
    }
  }
  @media screen and (max-width: 400px) {
    .stockup-ai-feature li span {
      font-size: 13px;
    }
  }
  @media screen and (max-width: 355px) {
    .stockup-ai-main-content .stockup-ai-feature {
      grid-template-columns: 1fr;
    }
  }
`;
